import React, { useRef, useState } from "react";
import { UploadCloud, X, Loader2 } from "lucide-react";
import api, { formatApiError } from "../api";

export default function ImageUploader({ value = [], onChange }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  const handleFiles = async (files) => {
    setErr("");
    setUploading(true);
    const urls = [...value];
    for (const file of Array.from(files)) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      } catch (e) {
        setErr(formatApiError(e.response?.data?.detail));
      }
    }
    onChange(urls);
    setUploading(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div data-testid="image-uploader">
      <div className="flex flex-wrap gap-3 mb-3">
        {value.map((url, i) => (
          <div key={i} className="relative group w-28 h-20 rounded-xl overflow-hidden border border-neutral-200">
            <img src={url} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute bottom-0 left-0 right-0 bg-brand-500 text-white text-[10px] text-center py-0.5">Cover</span>}
            <button type="button" onClick={() => remove(i)} data-testid={`remove-image-${i}`}
              className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        <button type="button" onClick={() => inputRef.current?.click()} data-testid="upload-image-btn"
          className="w-28 h-20 rounded-xl border-2 border-dashed border-neutral-300 flex flex-col items-center justify-center text-neutral-500 hover:border-brand-500 hover:text-brand-500 transition-colors">
          {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><UploadCloud className="w-5 h-5" /><span className="text-xs mt-1">Upload</span></>}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple hidden onChange={(e) => handleFiles(e.target.files)} data-testid="image-file-input" />
      <p className="text-xs text-neutral-400">Upload property photos (JPG/PNG/WebP, max 8MB each). First image is the cover.</p>
      {err && <p className="text-red-500 text-sm mt-1">{err}</p>}
    </div>
  );
}
